<p-dialog [visible]="visible" (visibleChange)="onVisibleChange($event)" [modal]="modal" [draggable]="draggable" [resizable]="resizable" [closable]="closable" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__icon">
          <div class="icon__state icon__state--success" *ngIf="type === 'success'">
            <app-success-icon color="color"></app-success-icon>
          </div>

          <div class="icon__state icon__state--error" *ngIf="type === 'error'">
            <app-error-icon color="color"></app-error-icon>
          </div>
        </div>
        <div class="dialog__info pb-25">
          <h2>{{ title }}</h2>
          <p>{{ message }}</p>
        </div>
        <div class="dialog__footer">
          <button pButton pRipple [label]="buttonLabel" [icon]="buttonIcon" [iconPos]="buttonIconPos" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="handleButtonClick()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
